<template>
    <div class="fw-msg">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <van-tabs>
            <van-tab title="快递订单">
                <KdOrder />
            </van-tab>
            <van-tab title="已发货记录">
                <FhOrder />
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import {getCookie,} from "../../../utils/auth";
    import KdOrder from "./kdorder";
    import FhOrder from "./fhorder";

    export default {
        components: {KdOrder,FhOrder},
        data() {
            return {
                title: '快递管理',
                fwUser: {},
                deptId: '',
                token: '',
                isCk: false,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
        },
        methods: {
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-msg {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
        padding-top: 46px;
        background-color: #FAFAFA;
    }



</style>